// extracted by mini-css-extract-plugin
export default {"transferWarningFlash":"IssueTransferDialog-module__transferWarningFlash--z3tha","noResultsContainer":"IssueTransferDialog-module__noResultsContainer--_HI9A"};